import { vehicleEntity } from '../entities/vehicle-entity';
import { OkapiConsolidatedData } from '../types/vehicle-types';
import { TrackingConfiguration, TrackingEventInfo, TrackingLink } from './tracking-types';

export const createTrackingLink = (name?: string): TrackingLink | undefined => {
	return {
		url: window ? window.location.href : undefined,
		name: name ? name : undefined,
	};
};

export const getBaseEventInfo = (pageCategory: string, brand: string | undefined): TrackingEventInfo => {
	const baseEventInfo: TrackingEventInfo = {
		brand: brand === 'N' ? 'commercial' : 'passenger',
		pageCategory,
		sectionName: undefined,
		templateType: 'Feature App Template',
	};
	return baseEventInfo;
};

export const getCarlineConfigurationForTracking = (
	vehiclePreconfiguration: OkapiConsolidatedData | undefined,
): TrackingConfiguration => {
	if (!vehiclePreconfiguration) return {};

	return {
		CarlineId: vehicleEntity.carlineCode,
		CarlineName: vehicleEntity.carlineTitle,
		SalesgroupId: vehicleEntity.salesgroupCode || '',
		SalesgroupName: vehicleEntity.salesgroupTitle || '',
		EquipmentlineName: vehicleEntity.trimlineName || '',
		ModelId: vehicleEntity.modelCode || '',
		ModelName: vehicleEntity.modelName || '',
		ModelYear: vehicleEntity.modelYear || '',
	};
};
